import { render } from "./Column202601.vue?vue&type=template&id=715a48d4&scoped=true"
import script from "./Column202601.vue?vue&type=script&lang=js"
export * from "./Column202601.vue?vue&type=script&lang=js"

import "./Column202601.vue?vue&type=style&index=0&id=715a48d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-715a48d4"

export default script